/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';

export const LdapQueryNames = {
   baseDN: 'baseDN',
   userFilter: 'userFilter',
   usernameAttribute: 'usernameAttribute',
   vfsGroup: 'vfsGroup',
} as const;
export const LdapQueryParams = yup.object({
   [LdapQueryNames.baseDN]: yup.string(),
   [LdapQueryNames.userFilter]: yup.string(),
   [LdapQueryNames.usernameAttribute]: yup.string(),
   [LdapQueryNames.vfsGroup]: yup.string(),
});
export type ILdapQueryParams = yup.InferType<typeof LdapQueryParams>;
